import { PrivateLayout } from 'Components';
import {
  AppliesLobby,
  MedicationHistory,
  MedicationsAndPrescriptionsLobby,
  ExpiredMedicationsLobby,
  Status,
  EquipmentCreateOrder,
  Equipment,
  TestLinks,
  TestComponents,
  FormsDetails,
  PersonalDetails,
  Requests,
  Paychecks,
  DisabledVeteran,
  Treatment,
  OTPLogin,
  UniversalRequest,
  Documents,
  Home,
  ActivitiesLobby,
  Updates,
  DisabilityConfirmations,
  EquipmentOrderInfo,
  MedicineOrderInfo,
} from 'Modules';
import { PersonalTeam } from 'Modules/PersonalTeam';
import { Confirmations } from 'Modules/Confirmations';
import { CompassRights } from 'Modules/CompassRights';
import { CompassRightsEntitlement } from 'Modules/CompassRightsEntitlement';
import { MedicalReferrals } from 'Modules/MedicalReferrals';
import { PaymentsAndDeductions } from 'Modules/PaymentsAndDeductions';
import { UniversalRequestLayout } from 'Components/UniversalRequestLayout';
import { OTPLoginLayout } from 'Components/OTPLoginLayout';
import { Error } from 'Modules/Error';
import { ErrorLayout } from 'Components/ErrorLayout';
import { TestImages } from 'Modules/TestImages';
import { OrderRegularMedicationsProvider } from 'Modules/MedicationsAndPrescriptionsLobby/OrderRegularMedicationsContext';
import { SingleStatus } from 'Modules/SingleStatus';
import { SuppliersLayout } from 'Components/SuppliersLayout';
import { Suppliers } from 'Modules/Suppliers';
import { B2CFirstLoginLanding } from 'Modules/B2C';
import { B2CError } from 'Components/B2CError';
import { SingleSupplier } from 'Modules/SingleSupplier';
import { LongtermEquipment } from 'Modules/LongtermEquipment';
import { Reimbursements } from 'Modules/Reimbursements';
import { Cannabis } from 'Modules/Reimbursements/Cannabis';
import { AlternativeMedicine } from 'Modules/Reimbursements/AlternativeMedicine';
import { DocumentsOld } from 'Modules/DocumentsOld';

interface Module {
  MODULE: JSX.Element;
  PATH: string;
}

interface ModuleCollection {
  [key: string]: Module;
}

export const RoutesConfig: ModuleCollection = {
  ERROR_LAYOUT: {
    MODULE: <ErrorLayout />,
    PATH: '/error',
  },
  ERROR: {
    MODULE: <Error />,
    PATH: '/error',
  },
  B2C_ERROR: {
    MODULE: <B2CError />,
    PATH: '/b2cError',
  },
  PRIVATE_LAYOUT: {
    MODULE: <PrivateLayout />,
    PATH: '/medicine',
  },
  UNIVERSAL_REQUEST_LAYOUT: {
    MODULE: <UniversalRequestLayout />,
    PATH: '/universalRequest',
  },
  OTP_LOGIN_LAYOUT: {
    MODULE: <OTPLoginLayout />,
    PATH: '/otp-login',
  },
  SUPPLIERS_LAYOUT: {
    MODULE: <SuppliersLayout />,
    PATH: '/suppliers',
  },
  SUPPLIERS: {
    MODULE: <Suppliers />,
    PATH: '/suppliers',
  },
  SINGLE_SUPPLIER: {
    MODULE: <SingleSupplier />,
    PATH: '/suppliers/:supplierCategoryId/results/:supplierSpecialty/:SupplierId',
  },
  HOME: {
    MODULE: <Home />,
    PATH: '/',
  },
  ActivitiesLobby: {
    MODULE: <ActivitiesLobby />,
    PATH: '/activities-lobby',
  },
  MEDICATION_AND_PRESCRIPTIONS_LOBBY: {
    MODULE: <MedicationsAndPrescriptionsLobby />,
    PATH: '/medicine',
  },
  MEDICATION_HISTORY: {
    PATH: '/medicine/MedicationHistory',
    MODULE: <MedicationHistory />,
  },
  MEDICINE_ORDER_INFO: {
    PATH: '/medicine/:id',
    MODULE: <MedicineOrderInfo />,
  },
  EXPIRED_MEDICATIONS: {
    PATH: '/medicine/ExpiredMedications',
    MODULE: <ExpiredMedicationsLobby />,
  },
  MEDICINE_CREATE_ORDER: {
    PATH: '/medicine/createOrder',
    MODULE: (
      <OrderRegularMedicationsProvider
        handleClose={() => {}}
        open
        openSuccessOrderDialog={() => {}}
        setSuccessOrderDialogExpiredPrescriptions={() => {}}
        isCreateOrder={true}
      />
    ),
  },
  STATUS: {
    PATH: '/RecognitionStatus',
    MODULE: <Status />,
  },
  SINGLE_STATUS: {
    PATH: '/RecognitionStatus/:claimEventNumber',
    MODULE: <SingleStatus />,
  },
  RECOGNITION_STATUS: {
    PATH: '/RecognitionStatus',
    MODULE: <PrivateLayout />,
  },
  APPLIES: {
    PATH: '/Applies',
    MODULE: <PrivateLayout />,
  },
  YOUR_APPLIES: {
    PATH: '/Applies',
    MODULE: <AppliesLobby />,
  },
  EQUIPMENT: {
    PATH: '/Equipment',
    MODULE: <Equipment />,
  },
  EQUIPMENT_CREATE_ORDER: {
    PATH: '/Equipment/CreateOrder',
    MODULE: <EquipmentCreateOrder />,
  },
  EQUIPMENT_ORDER_INFO: {
    PATH: '/Equipment/:id',
    MODULE: <EquipmentOrderInfo />,
  },
  REQUESTS: {
    PATH: '/requests/:formName/:id/:subId',
    MODULE: <Requests />,
  },
  TEST_LINKS: {
    PATH: '/test-links',
    MODULE: <TestLinks />,
  },
  TEST_COMPONENTS: {
    PATH: '/test-components',
    MODULE: <TestComponents />,
  },
  TEST_IMAGES: {
    PATH: '/test-images',
    MODULE: <TestImages />,
  },
  FORMS_DETAILS: {
    PATH: '/forms-details',
    MODULE: <FormsDetails />,
  },
  PERSONAL_DETAILS: {
    PATH: '/personal-details',
    MODULE: <PersonalDetails />,
  },
  PERSONAL_TEAM: {
    PATH: '/personal-team',
    MODULE: <PersonalTeam />,
  },
  CONFIRMATIONS: {
    PATH: '/confirmations',
    MODULE: <Confirmations />,
  },
  PAYCHECKS: {
    PATH: '/paychecks',
    MODULE: <Paychecks />,
  },
  DOCUMENTS: {
    PATH: '/documents-new',
    MODULE: <Documents />,
  },
  DOCUMENTS_OLD: {
    PATH: '/documents',
    MODULE: <DocumentsOld />,
  },
  COMPASS_RIGHTS: {
    PATH: '/compass-rights',
    MODULE: <CompassRights />,
  },
  COMPASS_RIGHTS_ENTITLEMENT: {
    PATH: '/compass-rights/:id',
    MODULE: <CompassRightsEntitlement />,
  },
  MEDICAL_REFERRALS: {
    PATH: '/medical-referrals',
    MODULE: <MedicalReferrals />,
  },
  DISABLED_VETERAN: {
    PATH: '/disabled-veteran',
    MODULE: <DisabledVeteran />,
  },
  TREATMENT: {
    PATH: '/treatment',
    MODULE: <Treatment />,
  },
  CONFIRM_BENEFITS: {
    PATH: '/payments&deductions',
    MODULE: <PaymentsAndDeductions />,
  },
  OTP_LOGIN: {
    PATH: '/otp-login',
    MODULE: <OTPLogin />,
  },
  UNIVERSAL_REQUEST: {
    PATH: '/UniversalRequest',
    MODULE: <UniversalRequest />,
  },
  UPDATES: {
    PATH: '/Updates',
    MODULE: <Updates />,
  },
  DISABILITY_APPROVALS: {
    PATH: '/disability-confirmations',
    MODULE: <DisabilityConfirmations />,
  },
  B2C_FIRST_LOGIN_LANDING: {
    PATH: '/contact-details',
    MODULE: <B2CFirstLoginLanding />,
  },
  LONG_TERM_EQUIPMENT: {
    PATH: '/longterm-equipment',
    MODULE: <LongtermEquipment />,
  },
  REIMBURSEMENTS: {
    PATH: '/Reimbursements',
    MODULE: <Reimbursements />,
  },
  CANNABIS: {
    PATH: '/Reimbursements/Cannabis',
    MODULE: <Cannabis />,
  },
  ALTERNATIVE_MEDICINE: {
    PATH: '/Reimbursements/Alternative-medicine',
    MODULE: <AlternativeMedicine />,
  },
};

export type RoutesConfigType = keyof typeof RoutesConfig;
